import { createStyled, shouldForwardProp } from '@mui/system';
import { defaultTheme } from './theme';
export var rootShouldForwardProp = function (prop) { return shouldForwardProp(prop) && prop !== 'classes'; };
export var styled = createStyled({
    defaultTheme: defaultTheme,
    rootShouldForwardProp: rootShouldForwardProp,
});
